var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 81,
    viewBox: "0 0 350 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4626_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.735 0.924316C146.39 0.924316 153.234 3.22345 158.294 7.8217C163.353 12.42 165.883 18.5981 165.883 26.3303C165.883 33.4332 163.199 39.3288 157.844 44.0426C152.849 48.4354 146.672 50.6317 139.301 50.6317H106.287V0.924316H137.735ZM139.995 43.2206C144.939 43.2206 148.996 41.6279 152.181 38.4297C155.366 35.2314 156.958 31.1341 156.958 26.1248C156.958 20.7944 155.25 16.4916 151.847 13.2292C148.431 9.9667 143.963 8.33548 138.428 8.33548H114.531V43.2206H139.995Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.673 50.6446H217.658L211.931 39.5214H178.454L172.727 50.6446H163.712L190.011 0.924316H200.374L226.673 50.6446ZM207.925 32.0974L195.263 8.01437L182.448 32.0974H207.925Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.269 0.924316C270.924 0.924316 277.768 3.22345 282.827 7.8217C287.887 12.42 290.417 18.5981 290.417 26.3303C290.417 33.4332 287.733 39.3288 282.378 44.0426C277.383 48.4354 271.206 50.6317 263.835 50.6317H230.808V0.924316H262.269ZM264.541 43.2206C269.485 43.2206 273.543 41.6279 276.728 38.4297C279.912 35.2314 281.505 31.1341 281.505 26.1248C281.505 20.7944 279.797 16.4916 276.394 13.2292C272.978 9.9667 268.509 8.33548 262.975 8.33548H239.077V43.2206H264.541Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.127 50.6446H297.082V0.924316H347.201V8.33548H305.326V21.1027H334.437V28.5139H305.326V43.2077H349.127V50.6446Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1415 23.3381L23.2939 40.1513H0.0512695L40.1415 0V23.3381Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3325 49.8486L40.1416 66.7003V89.9485L0 49.8486H23.3325Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8369 66.6619L66.6846 49.8616H89.9272L49.8369 90V66.6619Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6459 40.1512L49.8496 23.2994V0.0512695L89.9784 40.1512H66.6459Z",
    fill: "#007040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.364 79.5834H113.375L110.01 86.3138H105.092L119.423 58.4417H124.418L138.711 86.3138H133.754L130.364 79.5834ZM128.361 75.5246L121.889 62.616L115.417 75.5246H128.361Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.772 58.4417V73.1741C168.772 81.4201 163.738 87.1487 154.364 87.1487C145.028 87.1487 139.995 81.4201 139.995 73.1741V58.4417H144.528V72.853C144.528 79.1081 148.046 82.8843 154.364 82.8843C160.72 82.8843 164.239 79.0953 164.239 72.853V58.4417H168.772Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.591 77.9907L203.79 80.1871C201.299 84.2459 196.457 87.1615 189.754 87.1615C179.841 87.1615 173.6 81.5486 173.6 72.3906C173.6 63.2326 179.841 57.6196 189.934 57.6196C196.445 57.6196 201.273 60.561 203.738 64.5555L199.501 66.7905C197.536 63.361 194.172 61.8582 189.857 61.8582C182.859 61.8582 178.21 65.4418 178.21 72.4163C178.21 79.3907 182.859 82.9743 189.857 82.9743C194.185 82.9229 197.587 81.4586 199.591 77.9907Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.544 62.616H222.487V86.3138H217.954V62.616H205.96V58.4417H234.544V62.616Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.436 86.3138V58.4417H242.969V86.3138H238.436Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.259 72.3776C248.259 63.1811 254.538 57.6067 264.708 57.6067C274.879 57.6067 281.158 63.1811 281.158 72.3776C281.158 81.5742 274.879 87.1486 264.708 87.1486C254.538 87.1486 248.259 81.5742 248.259 72.3776ZM276.509 72.3776C276.509 65.6087 271.899 61.8196 264.708 61.8196C257.517 61.8196 252.869 65.6087 252.869 72.3776C252.869 79.1466 257.479 82.9356 264.708 82.9356C271.899 82.9228 276.509 79.1466 276.509 72.3776Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.585 58.4417V86.3138H311.579L290.892 64.3243V86.3138H286.5V58.4417H291.341L311.155 79.5834V58.4417H315.585Z",
    fill: "#76897F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 78.0677C350 83.3596 345.043 87.1486 336.041 87.1486C329.839 87.1486 324.356 85.2348 320.234 81.4971L323.072 78.1062C326.667 81.4971 330.905 82.9999 336.234 82.9999C342.128 82.9999 345.39 81.3687 345.39 78.453C345.39 75.5888 342.064 74.8309 335.412 74.2273C328.118 73.5851 321.235 71.8768 321.235 66.1867C321.235 60.6508 327.322 57.5811 334.924 57.5811C340.677 57.5811 345.557 59.3793 348.729 62.205L345.852 65.4675C343.13 62.9628 339.38 61.7683 335.001 61.7169C330.802 61.6784 325.807 62.7573 325.807 65.8528C325.807 68.7941 330.237 69.3207 336.016 69.796C344.247 70.5024 350 72.2621 350 78.0677Z",
    fill: "#76897F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4626_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalLogo);
export default __webpack_public_path__ + "static/media/final-logo.09ae9c4a6715e9810f1773723e3117d6.svg";
export { ForwardRef as ReactComponent };